import React from 'react';
import { ScrollView, StyleSheet, View, useWindowDimensions } from 'react-native';
import RenderHTML from 'react-native-render-html';
import { CommonProperties } from '../../styles';
import BaseText from '../BaseText';

const MessagesModal = ({ route }) => {
  const { message } = route.params;
  const { width } = useWindowDimensions();
  const source = {
    html: message.MessageContent,
  };
  return (
    <>
      {message && (
        <ScrollView>
          <View style={styles.messagesView}>
            <BaseText style={CommonProperties.h2}>{message.MessageTitle}</BaseText>
            <RenderHTML source={source} contentWidth={width} />
          </View>
        </ScrollView>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  messagesView: {
    flex: 1,
    ...CommonProperties.p3,
  },
});

export default MessagesModal;
